<!-- 课外活动 -->
<template>
  <div class="extracurricular">
    <h1 class="application-title">课外活动</h1>
    <div class="application-smart-title dis-40">
      List ALL extracurricular, community and leadership experiences, no matter how little your involvement
    </div>
    <Form ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate">
      <div class="extracurricular-form">
        <div class="dis-96"
             v-for="(item, index) in formValidate.schoolActivities"
             :key="index">
          <zlr-card-shink :title="'课外活动 '+(index+1)">
            <div class="w720 dis-40">
              <div class="delete"
                   v-if="index!=0"
                   @click="removeSchoolActivitie(index)"></div>
              <FormItem label="Organization"
                        prop="name"
                        :label-width="226">
                <Input v-model="item.name"
                       placeholder="e.g. IUCN"></Input>
              </FormItem>
              <FormItem label="Role Title"
                        prop="name"
                        :label-width="226">
                <Input v-model="item.title"
                       placeholder="e.g. Volunteer"></Input>
              </FormItem>
              <FormItem label="Start Date"
                        prop="name"
                        :label-width="226">
                <DatePicker type="date"
                            placeholder="Select date"
                            v-model="item.startDate"
                            style="width:100%;"></DatePicker>
              </FormItem>
              <FormItem label="Time Commitment"
                        prop="name"
                        :label-width="226">
                <Input v-model="item.duration"
                       placeholder="e.g. 3 months"></Input>
              </FormItem>
            </div>
            <div class="label-bot-20">
              <FormItem label='Description of experience'
                        prop="name">
                <Input v-model="item.description"
                       placeholder="Please limit your response to 500 words"
                       type="textarea"
                       :rows="5"> </Input>
              </FormItem>
            </div>
          </zlr-card-shink>
        </div>
        <div class="application-order-add"
             @click="addSchoolActivitie">添加更多 课外活动</div>
        <div class="sub-btn" v-if="isallowedit">
          <Affix :offset-bottom="20">
            <Button type="primary"
                    style="width:96px;"
                    @click="saveHandle">保存</Button>
          </Affix>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import isAllowEdit from '@/view/mixins/is-edit'
//  api
import { infoQueryActivities, infoModifyActivities } from '@/api/info'
// components
import ZlrCardShink from '_c/card-shrink/card-shrink'
export default {
  name: 'application-extracurricular',
  mixins: [isAllowEdit],
  components: {
    ZlrCardShink
  },
  data () {
    return {
      formValidate: {},
      ruleValidate: {}
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      infoQueryActivities().then(res => {
        let data = res.data.model || {}

        this.formValidate = Object.assign({}, data)

        this.$set(this.formValidate, 'schoolActivities', data.schoolActivities || [{}])
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    saveHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)

          infoModifyActivities(data).then(res => {
            this.$zlr_message('保存成功', 'success')
            this.$router.push({
              name: 'application-family'
            })
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          })
        }
      })
    },
    addSchoolActivitie () {
      this.formValidate.schoolActivities.push({
        name: '',
        description: ''
      })
    },
    removeSchoolActivitie (index) {
      this.formValidate.schoolActivities.splice(index, 1)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
